// imageのrurlをwebpのurlに変換する
export const convertToWebpUrl = (url: string) => {
  return url.replace(/^(.+\/)?(.+?)\.(jpg|jpeg|png)$/, "$1webp/$2.webp");
};
